import StorageUtils from '../../utils/storage';
import {AuthActionType} from '../actions/actionTypes';

const user = StorageUtils.getUser();

const defaultState = {
  isAuthenticated: false,
};

export const initialState = user || defaultState;
const authReducer = (state = initialState, action) => {
  let result = {};
  switch (action.type) {
    case AuthActionType.SET_USER:
      result = {
        ...state,
        ...action.data,
        isAuthenticated: true,
      };
      StorageUtils.setUser({
        ...initialState,
        ...(result?.userToken && {token: result?.userToken}),
        isAuthenticated: result?.isAuthenticated,
      });
      return result;
    default:
      return state;
  }
};

export default authReducer;
